exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*Ellipsis animation for pending results*/\n/*source: https://codepen.io/thetallweeks/pen/yybGra*/\n.pending:after {\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: bottom;\n  animation: ellipsis steps(4,end) 900ms infinite;\n  content: '\\2026';\n  width: 0;\n}\n\n@keyframes ellipsis {\n  to {\n    width: 1.25em\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workspace/NodeJs/cpk-frontend/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/ubuntu/workspace/NodeJs/cpk-frontend/node_modules/postcss-loader?{"ident":"postcss"}!/home/ubuntu/workspace/NodeJs/cpk-frontend/src/assets/css/pending.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/pending.css
// module chunks = styles